import React from 'react';
import { CustomTable } from '@quyva/shared-ui';

export const TasksTablePane = ({
    filteredTasks,
    columns,
    selectedTaskId,
    setSelectedTaskId,
    shouldEnableHorizontalScroll,
    hasUserDraggedTaskSplitter,
    leftTableContainerRef,
    leftTableContainerWidth,
    leftTableContainerHeight,
    setHasUserDraggedTaskSplitter,
    selectedTask,
    currentPage,
    setCurrentPage,
}) => {
    const TABLE_MIN_WIDTH = 900;

    if (!selectedTask) {
        return (
            <div
                ref={leftTableContainerRef}
                className='w-full h-full bg-backgrounds-white overflow-hidden'
            >
                <CustomTable
                    className='[&_.ant-table-thead>tr>th]:!bg-slate-100'
                    dataSource={filteredTasks}
                    columns={columns}
                    rowKey='id'
                    tableLayout='fixed'
                    pagination={{
                        current: currentPage,
                        pageSize: 9,
                        showSizeChanger: false,
                        onChange: (page) => setCurrentPage(page),
                    }}
                    onRow={(record) => ({
                        onClick: () => setSelectedTaskId(record.id),
                    })}
                    rowClassName={(record) =>
                        record.id === selectedTaskId ? 'bg-backgrounds-primary100/60' : ''
                    }
                />
            </div>
        );
    }

    return (
        <div
            ref={leftTableContainerRef}
            className='w-full h-full min-w-0 overflow-x-auto overflow-y-hidden'
        >
            <CustomTable
                variant='split'
                className='[&_.ant-table-thead>tr>th]:!bg-slate-100'
                dataSource={filteredTasks}
                columns={columns}
                rowKey='id'
                tableLayout='fixed'
                scroll={{ x: TABLE_MIN_WIDTH }}
                pagination={{
                    current: currentPage,
                    pageSize: 9,
                    showSizeChanger: false,
                    onChange: (page) => setCurrentPage(page),
                }}
                onRow={(record) => ({
                    onClick: () => setSelectedTaskId(record.id),
                })}
                rowClassName={(record) =>
                    record.id === selectedTaskId ? 'bg-backgrounds-primary100/60' : ''
                }
                onHeaderRow={() => ({
                    onMouseUp: () => {
                        if (!hasUserDraggedTaskSplitter) {
                            setHasUserDraggedTaskSplitter(true);
                        }
                    },
                })}
            />
        </div>
    );
};
